<template>
  <div class="section usage">
    <div class="content">
      <div>
        From:
        <input type="date" id="start" v-model="dateFrom" />
        　To:
        <input type="date" id="start" v-model="dateTo" :max="today()" />
      </div>

      <!-- ラジオボタン -->
      <div class="mt-3">
        <input type="radio" checked/>
        <label>{{ $t("Home.oneday_fifo") }}</label>
      </div>

      <!-- 入出庫がない履歴データを除外する -->
      <div class="mt-3">
        <div>
          <input type="checkbox" id="only_purchase_and_packing_slip2" v-model="is_only_purchase_and_packing_slip" />
          <label for="only_purchase_and_packing_slip2">{{ $t("Home.only_purchase_and_packing_slip") }}</label>
        </div>
      </div>

      <div v-if="isLoading" class="mt-4">
        <button class="btn btn-primary" type="button" disabled>
          <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
          <span class="visually-hidden">Loading...</span>
        </button>

        &nbsp;
        <button class="btn btn-light" type="button" @click="cancel()">
          <span>Cancel</span>
        </button>
        <div class="content_note">
          <div>※{{ $t("Home.aLotOfInventory") }}</div>
          <div>※{{ $t("Home.inBackground") }}</div>
        </div>
      </div>
      <div v-else class="mt-4">
        <button class="btn btn-primary" @click="aggregateBtnClicked()">{{ $t("Home.tally") }}</button>
      </div>

      <!-- ヘルプページ -->
      <div class="mt-3">
        <div v-if="selectedLanguage == 'ja'">
          {{ $t("Home.help_ja_1") }}
          <a href="https://support.zaico.co.jp/hc/ja/articles/5212791543321" target="_blank">
            {{ $t("Home.help_ja_2") }}
          </a>
          {{ $t("Home.help_ja_3") }}
        </div>
        <div v-else>
          {{ $t("Home.help_en_1") }}
          <a href="https://support.zaico.co.jp/hc/ja/articles/5212791543321" target="_blank">
            {{ $t("Home.help_en_2") }}
          </a>
        </div>
      </div>

      <div v-if="isShowError">
        <br />
        <div class="alert alert-danger" role="alert">
          <span>
            {{ errorMsg }}
            &nbsp;
            <a href="https://www.zaico.co.jp/smart-zaico/help/contact/" target="_blank">HELP</a>
          </span>
        </div>
      </div>

      <!-- 進捗バー -->
      <br />
      <div v-if="isLoading" class="progress">
        <div
          class="progress-bar progress-bar-striped progress-bar-animated"
          role="progressbar"
          :aria-valuenow="progressPercent"
          aria-valuemin="0"
          aria-valuemax="100"
          :style="{ width: progressPercentStr }"
        >
          {{ progressPercentStr }}
        </div>
      </div>

      <!-- 集計完了 -->
      <div v-if="isCompletedCreateZaicoMoneyList">
        <div>[{{ dateFrom }}]{{ $t("Home.totalAmount") }}：{{ totalAmountDateFrom.toLocaleString() }}</div>
        <div>[{{ $t("Home.receive") }}]{{ $t("Home.totalAmount") }}：{{ totalAmountReceive.toLocaleString() }}</div>
        <div>
          [{{ $t("Home.shippingOut") }}]{{ $t("Home.totalAmount") }}：{{ totalAmountShippingOut.toLocaleString() }}
        </div>
        <div>[{{ dateTo }}]{{ $t("Home.totalAmount") }}：{{ totalAmountDateTo.toLocaleString() }}</div>
        <!-- 詳細データ -->
        <div style="margin-top: 1rem; border: darkgray 1px solid; padding: 1rem">
          <div class="fs-3 fw-bold">
            {{ $t("Home.detailed_data") }}
          </div>
          <div style="margin-left: 2rem">
            <div>{{ $t("Home.totalNumber") }}：{{ zaicoMoneyList.length.toLocaleString() }}</div>
            <!-- ボタン -->
            <div class="mt-3">
              <div class="button-container">
                <div v-if="isShowPreview">
                  <button class="btn btn-info" @click="closePreview()">{{ $t("Home.closeTallyResults") }}</button>
                </div>
                <div v-else>
                  <button class="btn btn-info" :disabled="zaicoMoneyList.length === 0" @click="openPreview()">{{ $t("Home.viewTallyResults") }}</button>
                </div>
                <button
                  class="btn btn-primary"
                  @click="downloadCSV(zaicoMoneyList, column_names, 'TowDays_downloadCSV')"
                >
                  {{ $t("Home.CSVDownload") }}
                </button>
              </div>
            </div>
            <!-- プレビュー表示 -->
            <div v-if="isShowPreview" class="mt-3">
              <!-- プレビューデータ -->
              <div v-if="zaicoMoneyList.length > 1000">・{{ $t("Home.upTo1000") }}</div>
              <vue-good-table
                :columns="columns"
                :rows="zaicoMoneyList.slice(0, 1000)"
                max-height="500px"
                :fixed-header="false"
                :row-style-class="rowStyleClassFn"
                @on-row-click="onRowClick"
                :pagination-options="{
                  enabled: false,
                  mode: 'records',
                  perPage: 100,
                  position: 'top',
                  perPageDropdown: [10, 50, 100],
                  nextLabel: '次のページ',
                  prevLabel: '前のページ',
                  rowsPerPageLabel: '１ページ当たりの件数',
                  infoFn: (params) => `合計：${params.totalRecords}件　現在： ${params.currentPage}ページ目`,
                }"
              />
              <!-- プレビュー警告 -->
              <div v-if="hasNoPriceData">
                <div class="alert alert-warning mt-2" role="alert">
                  <strong class="fs-3">{{ $t("Home.hasNoPriceData1") }}</strong>
                  <div>{{ $t("Home.hasNoPriceData2") }}</div>
                  <div>{{ $t("Home.hasNoPriceData6") }}</div>
                  <div>{{ $t("Home.hasNoPriceData3") }}</div>
                  <ul>
                    <li>{{ $t("Home.hasNoPriceData4") }}</li>
                    <li>{{ $t("Home.hasNoPriceData5") }}</li>
                    <li>{{ $t("Home.hasNoPriceData7") }}</li>
                  </ul>
                </div>
              </div>
              <!-- グラフ -->
              <div class="mt-4" v-if="chartData.labels.length > 0">
                <BaseBarChart :chartData="chartData" />
              </div>
            </div>
          </div>
        </div>
        <!-- 集計データ -->
        <div style="margin-top: 2rem; border: darkgray 1px solid; padding: 1rem">
          <div class="fs-3 fw-bold">
            {{ $t("Home.aggregate_data") }}
          </div>
          <div style="margin-left: 2rem">
            <div>{{ $t("Home.totalNumber") }}：{{ zaicoMoneyAggregatedList.length.toLocaleString() }}</div>
            <!-- ボタン -->
            <div class="mt-3">
              <div v-if="!is_advanced_plan">
                <div class="alert alert-warning mt-3" role="alert">
                  <div>{{ $t("Home.advanced_plan_warning_detail_1") }}</div>
                  <div>{{ $t("Home.advanced_plan_warning_detail_2") }}</div>
                </div>
              </div>
              <div class="button-container">
                <div v-if="isShowAggregatedPreview">
                  <button class="btn btn-info" @click="closeAggregatedPreview()">
                    {{ $t("Home.closeTallyResults") }}
                  </button>
                </div>
                <div v-else>
                  <button class="btn btn-info" :disabled="zaicoMoneyAggregatedList.length === 0" @click="openAggregatedPreview()">
                    {{ $t("Home.viewTallyResults") }}
                  </button>
                </div>
                <button
                  class="btn btn-primary"
                  :disabled="!is_advanced_plan"
                  @click="downloadCSV(zaicoMoneyAggregatedList, column_names, 'TowDays_downloadAggregatedCSV')"
                >
                  {{ $t("Home.CSVDownload") }}
                </button>
              </div>
            </div>
            <!-- プレビュー表示 -->
            <div v-if="isShowAggregatedPreview" class="mt-3">
              <!-- プレビューデータ -->
              <div v-if="is_advanced_plan && zaicoMoneyAggregatedList.length > 1000">・{{ $t("Home.upTo1000") }}</div>
              <vue-good-table
                :columns="columns"
                :rows="zaicoMoneyAggregatedList.slice(0, maxPreviewRowsAggregatedList)"
                max-height="500px"
                :fixed-header="false"
                :row-style-class="rowStyleClassFn"
                @on-row-click="onRowClick"
                :pagination-options="{
                  enabled: false,
                  mode: 'records',
                  perPage: 100,
                  position: 'top',
                  perPageDropdown: [10, 50, 100],
                  nextLabel: '次のページ',
                  prevLabel: '前のページ',
                  rowsPerPageLabel: '１ページ当たりの件数',
                  infoFn: (params) => `合計：${params.totalRecords}件　現在： ${params.currentPage}ページ目`,
                }"
              />
              <!-- プレビュー警告 -->
              <div v-if="hasNoPriceData">
                <div class="alert alert-warning mt-2" role="alert">
                  <strong class="fs-3">{{ $t("Home.hasNoPriceData1") }}</strong>
                  <div>{{ $t("Home.hasNoPriceData2") }}</div>
                  <div>{{ $t("Home.hasNoPriceData6") }}</div>
                  <div>{{ $t("Home.hasNoPriceData3") }}</div>
                  <ul>
                    <li>{{ $t("Home.hasNoPriceData4") }}</li>
                    <li>{{ $t("Home.hasNoPriceData5") }}</li>
                    <li>{{ $t("Home.hasNoPriceData7") }}</li>
                  </ul>
                </div>
              </div>
              <!-- グラフ -->
              <div class="mt-4" v-if="chartData.labels.length > 0">
                <BaseBarChart :chartData="chartData" />
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>

  <!-- isCompletedFetchAllを監視させるためのダミーエレメント -->
  <div style="display: none">{{ isCompletedFetchAll }}</div>
</template>

<script>
// API実行
import axios from "axios";
// loading
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
// table
import VueGoodTable from "./../components/vue3-good-table-main/Table";
// 共通メソッド
import useCommonMethods from "./../useCommonMethods.js";
// グラフ
import BaseBarChart from "./../components/BaseBarChart.vue";

export default {
  name: "Home",
  components: {
    Loading,
    VueGoodTable,
    BaseBarChart,
  },
  props: ["selectedLanguage", "is_advanced_plan", "maxPreviewRowsAggregatedList"],
  data() {
    return {
      NODE_ENV: process.env.NODE_ENV,
      dateFrom: this.endOfTwoMonthsAgo(),
      dateTo: this.endOfLastMonth(),
      zaicoMoneyList: [],
      zaicoMoneyAggregatedList: [],
      pastInventories: [], // dateFrom時点の在庫一覧
      iventoriesAtDateTo: {}, // dateTo時点の在庫一覧json。key:在庫ID value:[APIレスポンス全部]
      current_inventories: [],
      histories_plus: [],
      all_histories: {},
      histories_canceled: {},
      purchase_items: {},
      deliveries: {},
      isCompletedFetchPastInventories: false,
      isCompletedFetchInventories: false,
      isCompletedFetchCurrentInventories: false,
      isCompletedFetchAllHistories: false,
      isCompletedFetchPurchasesItems: false,
      isCompletedFetchDeliveries: false,
      isCompletedCreateZaicoMoneyList: false,
      previousIsCompletedFetchAll: false,
      isLoading: false,
      isCreating: false,
      isShowError: false,
      isShowPreview: false,
      isShowAggregatedPreview: false,
      errorMsg: "",
      columns: [],
      column_names: [],
      progress: 0,
      progressPercentStr: "",
      hasNoPriceData: false,
      totalAmountDateFrom: 0,
      totalAmountDateTo: 0,
      totalAmountReceive: 0,
      totalAmountShippingOut: 0,
      userName: "",
      userId: "",
      companyName: "",
      planName: "",
      chartData: {
        titleText: "",
        labels: [],
        datasets: [
          {
            label: "在庫金額",
            data: [],
          },
        ],
      },
      is_only_purchase_and_packing_slip: false,
      calc_errors: {},
    };
  },
  created() {
    const is_only_purchase_and_packing_slip = localStorage.getItem("is_only_purchase_and_packing_slip");
    if (is_only_purchase_and_packing_slip == 'true') {
      this.is_only_purchase_and_packing_slip = true;
    } else {
      this.is_only_purchase_and_packing_slip = false;
    }
  },
  computed: {
    accessToken: function () {
      return this.$store.state.accessToken;
    },
    /**
     * プログレスバー
     */
    progressPercent: function () {
      let progressPercent = 0;
      progressPercent = this.progress * 100;
      progressPercent = Math.round(progressPercent);
      this.progressPercentStr = progressPercent + "%";
      return progressPercent;
    },
    /**
     * データが揃ったら在庫金額の計算を開始する
     */
    isCompletedFetchAll: async function () {
      const isCompletedFetchAll =
        this.isCompletedFetchPastInventories &&
        this.isCompletedFetchInventories &&
        this.isCompletedFetchCurrentInventories &&
        this.isCompletedFetchAllHistories &&
        this.isCompletedFetchPurchasesItems &&
        this.isCompletedFetchDeliveries;

      if (isCompletedFetchAll && !this.previousIsCompletedFetchAll && this.isLoading && !this.isCreating && !this.isShowError) {
        this.isCreating = true;
        // 詳細データ
        await this.createZaicoMoney();
        // 物品集計データ
        if (this.selectedLanguage == "ja") {
          this.zaicoMoneyAggregatedList = this.createAggregatedZaicoMoney(
            this.zaicoMoneyList,
            "仕入単価",
            this.dateFrom + "の数量",
            this.dateFrom + "の在庫金額",
            this.dateTo + "の数量",
            this.dateTo + "の在庫金額",
            "入庫の数量",
            "入庫の在庫金額",
            "出庫の数量",
            "出庫の在庫金額"
          );
        } else {
          this.zaicoMoneyAggregatedList = this.createAggregatedZaicoMoney(
            this.zaicoMoneyList,
            "Unit Price",
            "Quantity at " + this.dateFrom,
            "Inventory Money Amount at " + this.dateFrom,
            "Quantity at " + this.dateTo,
            "Quantity Inventory Money Amount" + this.dateTo,
            "Incoming Quantity",
            "Incoming Inventory Money Amount",
            "Outgoing quantity",
            "Outgoing Inventory Money Amount"
          );
        }
        this.zaicoMoneyAggregatedList = this.delete_zaico_money_due_to_errors(this.zaicoMoneyAggregatedList, this.calc_errors)

        this.chartData = this.createChartData(this.zaicoMoneyList, this.dateTo);

        console.log("this.calc_errors:");
        console.log(JSON.parse(JSON.stringify(this.calc_errors)));
        if (Object.keys(this.calc_errors).length > 0) {
          this.hasNoPriceData = true;
        }

        this.isCompletedCreateZaicoMoneyList = true;
        this.isLoading = false;
      }
      this.previousIsCompletedFetchAll = isCompletedFetchAll;

      this.isCreating = false;
      return isCompletedFetchAll;
    },
  },
  methods: {
    ...useCommonMethods(),
    /**
     * 在庫金額データを作成する
     * @type {function}
     */
    async createZaicoMoney() {
      console.log("---------------------- start createZaicoMoney ----------------------");

      this.pastInventories = this.merge_current_inventories(this.pastInventories, this.current_inventories);
      console.log("[merge_current_inventories] this.pastInventories: ");
      console.log(JSON.parse(JSON.stringify(this.pastInventories)));

      console.log("[merge_current_inventories] this.iventoriesAtDateTo: ");
      console.log(JSON.parse(JSON.stringify(this.iventoriesAtDateTo)));
      this.iventoriesAtDateTo = this.merge_current_inventories_at_date_to(
        this.iventoriesAtDateTo,
        this.current_inventories
      );
      console.log("[merge_current_inventories] this.iventoriesAtDateTo: ");
      console.log(JSON.parse(JSON.stringify(this.iventoriesAtDateTo)));

      const history_operation_datetime_for_purchase_items = this.create_operation_datetime_for_purchase_items(
        this.all_histories
      );
      console.log("[create_operation_datetime_for_purchase_items] history_operation_datetime_for_purchase_items: ");
      console.log(JSON.parse(JSON.stringify(history_operation_datetime_for_purchase_items)));

      this.pastInventories = this.calc_quantity_by_past_purchase_date(
        this.pastInventories,
        this.purchase_items,
        this.dateFrom,
        history_operation_datetime_for_purchase_items,
        this.calc_errors
      );
      console.log("[calc_quantity_by_past_purchase_date] this.pastInventories: ");
      console.log(JSON.parse(JSON.stringify(this.pastInventories)));

      const history_operation_datetime_for_deliveries = this.create_operation_datetime_for_deliveries(
        this.all_histories
      );
      console.log("[create_operation_datetime_for_deliveries] history_operation_datetime_for_deliveries: ");
      console.log(JSON.parse(JSON.stringify(history_operation_datetime_for_deliveries)));

      this.pastInventories = this.calc_quantity_by_past_delivery_date(
        this.pastInventories,
        this.deliveries,
        this.dateFrom,
        history_operation_datetime_for_deliveries,
        this.calc_errors
      );
      console.log("[calc_quantity_by_past_delivery_date] this.pastInventories: ");
      console.log(JSON.parse(JSON.stringify(this.pastInventories)));

      this.pastInventories = this.calc_quantity_by_canceled_history(
          this.pastInventories,
          this.histories_canceled,
          this.purchase_items,
          this.deliveries,
          this.dateFrom
        )
      console.log("[calc_quantity_by_canceled_history] this.pastInventories: ");
      console.log(JSON.parse(JSON.stringify(this.pastInventories)));

      console.log("this.dateFrom: ", this.dateFrom);
      console.log("this.histories_plus: ");
      console.log(JSON.parse(JSON.stringify(this.histories_plus)));
      console.log("this.purchase_items: ");
      console.log(JSON.parse(JSON.stringify(this.purchase_items)));

      let purchasesItemsAndHistories
      if (this.is_only_purchase_and_packing_slip) {
        purchasesItemsAndHistories = this.purchase_items;
      } else {
        purchasesItemsAndHistories = this.mergePurchasesItemsAndHistories(this.purchase_items, this.histories_plus);
      }
      console.log("purchasesItemsAndHistories: ");
      console.log(JSON.parse(JSON.stringify(purchasesItemsAndHistories)));

      const purchasesItemsFilterd = this.filterPurchasesItems(purchasesItemsAndHistories, "2000-01-01", this.dateFrom);
      console.log("purchasesItemsFilterd: ");
      console.log(JSON.parse(JSON.stringify(purchasesItemsFilterd)));

      const purchasesItemsSorted = this.sortPurchasesItems(purchasesItemsFilterd);
      console.log("purchasesItemsSorted: ");
      console.log(JSON.parse(JSON.stringify(purchasesItemsSorted)));

      let zaicoMoneyJson = this.createZaicoMoneyJson(
        this.pastInventories,
        {},
        purchasesItemsSorted,
        this.dateFrom,
        this.is_only_purchase_and_packing_slip,
        {}
      );

      await this.addReceive(zaicoMoneyJson);
      console.log("[addReceive] zaicoMoneyJson: ");
      console.log(JSON.parse(JSON.stringify(zaicoMoneyJson)));

      // createZaicoMoneyJsonとAddReceiveで作成されたJSONは仕入日の古い順に並んでいない
      // 先入先出法（addShippingOut）で割り当てるために事前に仕入日の昇順に並べ替えておく
      await this.sortByPurchaseDate(zaicoMoneyJson);
      console.log("[sortByPurchaseDate] zaicoMoneyJson: ");
      console.log(JSON.parse(JSON.stringify(zaicoMoneyJson)));

      await this.addShippingOut(zaicoMoneyJson);
      console.log("[addShippingOut] zaicoMoneyJson: ");
      console.log(JSON.parse(JSON.stringify(zaicoMoneyJson)));

      zaicoMoneyJson = this.aggregateSameUnitPrice(zaicoMoneyJson, this.dateFrom);
      console.log("");
      console.log("[aggregateSameUnitPrice] zaicoMoneyJson: ");
      console.log(JSON.parse(JSON.stringify(zaicoMoneyJson)));

      this.zaicoMoneyJson = this.calcZaicoMoney(zaicoMoneyJson);
      console.log("[calcZaicoMoney] this.zaicoMoneyJson: ");
      console.log(JSON.parse(JSON.stringify(this.zaicoMoneyJson)));

      this.zaicoMoneyJson = this.remove_unnecessary_data(this.zaicoMoneyJson);
      console.log("[remove_unnecessary_data] this.zaicoMoneyJson: ");
      console.log(JSON.parse(JSON.stringify(this.zaicoMoneyJson)));

      this.zaicoMoneyList = this.convertJsonToList(zaicoMoneyJson);
      console.log("this.zaicoMoneyList: ");
      console.log(JSON.parse(JSON.stringify(this.zaicoMoneyList)));

      this.zaicoMoneyList = this.sort(this.zaicoMoneyList);
      console.log("this.zaicoMoneyList: ");
      console.log(JSON.parse(JSON.stringify(this.zaicoMoneyList)));

      this.zaicoMoneyList = this.delete_zaico_money_due_to_errors(this.zaicoMoneyList, this.calc_errors)
      console.log("zaicoMoneyList: ");
      console.log(JSON.parse(JSON.stringify(this.zaicoMoneyList)));

      this.calcTotalAmount(this.zaicoMoneyList);

      const { columns, column_names } = this.getColumns(this.zaicoMoneyList);
      this.columns = columns;
      this.column_names = column_names;
    },

    merge_current_inventories_at_date_to(iventoriesAtDateTo, current_inventories) {
      console.log("start merge_current_inventories_at_date_to");
      let merged_inventories = iventoriesAtDateTo;
      current_inventories.forEach((current_inventory) => {
        const inventory_id = current_inventory["id"];
        if (!merged_inventories[inventory_id]) {
          merged_inventories[inventory_id] = { ...current_inventory, quantity: "0" };
        }
      });
      console.log("end merge_current_inventories_at_date_to");
      return merged_inventories;
    },

    /**
     * 在庫金額一覧jsonに入庫の列を追加する。
     * メモリ節約のため、破壊的変更にしている。
     * @type {function}
     * @param {json} zaicoMoneyJson - 在庫金額一覧Json
     */
    async addReceive(zaicoMoneyJson) {
      console.log("this.dateFrom: ", this.dateFrom);
      console.log("this.dateTo: ", this.dateTo);
      const purchase_items = await this.loopFetchPurchasesItems(this.nextday(this.dateFrom), this.dateTo);
      console.log("[addReceive] purchase_items: ");
      console.log(JSON.parse(JSON.stringify(purchase_items)));

      const histories_plus = this.fillter_histories_plus(this.all_histories, this.dateTo, true);
      console.log("[addReceive] histories_plus: ");
      console.log(JSON.parse(JSON.stringify(histories_plus)));

      let purchasesItemsAndHistories
      if (this.is_only_purchase_and_packing_slip) {
        purchasesItemsAndHistories = purchase_items;
      } else {
        purchasesItemsAndHistories = this.mergePurchasesItemsAndHistories(purchase_items, this.histories_plus);
      }
      console.log("[addReceive] purchasesItemsAndHistories: ");
      console.log(JSON.parse(JSON.stringify(purchasesItemsAndHistories)));

      const purchasesItemsFilterd = this.filterPurchasesItems(purchasesItemsAndHistories, this.dateFrom, this.dateTo);
      console.log("purchasesItemsFilterd: ");
      console.log(JSON.parse(JSON.stringify(purchasesItemsFilterd)));

      const purchasesItemsSorted = this.sortPurchasesItems(purchasesItemsFilterd);
      console.log("[addReceive] purchasesItemsSorted: ");
      console.log(purchasesItemsSorted);

      zaicoMoneyJson = this.addNewlyAddedQuantity(zaicoMoneyJson, purchasesItemsSorted);
      console.log("[addNewlyAddedQuantity] zaicoMoneyJson: ");
      console.log(JSON.parse(JSON.stringify(zaicoMoneyJson)));

      zaicoMoneyJson = this.addReceiveZaicoMoney(zaicoMoneyJson, purchasesItemsSorted, this.iventoriesAtDateTo);
      console.log("[addReceiveZaicoMoney] zaicoMoneyJson: ");
      console.log(JSON.parse(JSON.stringify(zaicoMoneyJson)));
    },

    /**
     * 在庫金額一覧jsonの各入庫データを入庫日の昇順に並べ替える。
     * 仕入日が同じ場合は入庫ID（_purchase_id）が小さいものを古いとみなす。
     * ※ useCommonMethods.js の sortPurchasesItems（降順）と同じ規則で並べること
     * メモリ節約のため、破壊的変更にしている。
     * @type {function}
     * @param {json} zaicoMoneyJson - 在庫金額一覧Json
     */
    async sortByPurchaseDate(zaicoMoneyJson) {
      const field = '仕入日'

      for (const key in zaicoMoneyJson) {
        const arr = zaicoMoneyJson[key];

        arr.sort((a, b) => {
          const dateA = a[field] ? new Date(a[field]) : null;
          const dateB = b[field] ? new Date(b[field]) : null;

          if (dateA && dateB) {
            if (dateA - dateB !== 0) return dateA - dateB;
            return this.comparePurchaseIdAsc(a["_purchase_id"], b["_purchase_id"]);
          }
          if (!dateA && dateB) return 1;
          if (dateA && !dateB) return -1;
          return 0;
        });
      }
    },

    /**
     * 在庫金額一覧jsonに出庫の列を追加する。
     * メモリ節約のため、破壊的変更にしている。
     * @type {function}
     * @param {json} zaicoMoneyJson - 在庫金額一覧Json
     */
    async addShippingOut(zaicoMoneyJson) {
      const deliveries = await this.loopFetchDeliveries(this.nextday(this.dateFrom), this.dateTo);
      console.log("[addShippingOut] deliveries: ");
      console.log(JSON.parse(JSON.stringify(deliveries)));

      const histories_minus = this.fillter_histories_minus(this.all_histories, this.dateTo, true);
      console.log("histories_minus: ");
      console.log(JSON.parse(JSON.stringify(histories_minus)));

      let deliveriesAndHistories
      if (this.is_only_purchase_and_packing_slip) {
        deliveriesAndHistories = deliveries;
      } else {
        deliveriesAndHistories = this.mergeDeliveriesAndHistories(deliveries, histories_minus);
      }
      console.log("deliveriesAndHistories: ");
      console.log(JSON.parse(JSON.stringify(deliveriesAndHistories)));

      const deliveriesFilterd = this.filterDeliveries(deliveriesAndHistories, this.dateFrom, this.dateTo);
      console.log("deliveriesFilterd: ");
      console.log(JSON.parse(JSON.stringify(deliveriesFilterd)));

      const deliveriesSorted = this.sortDeliveries(deliveriesFilterd);
      console.log("deliveriesSorted: ");
      console.log(deliveriesSorted);

      zaicoMoneyJson = this.addShippingOutZaicoMoney(zaicoMoneyJson, deliveriesSorted, this.dateFrom);
      console.log("");
      console.log("[addShippingOutZaicoMoney] zaicoMoneyJson: ");
      console.log(JSON.parse(JSON.stringify(zaicoMoneyJson)));
    },

    /**
     * 在庫金額一覧jsonに期間中に新規追加データを追加する。
     * 新規追加データは変更履歴だと数量差分0なので取得できないので、"期間To - 出庫総数"として算出する。
     * @type {function}
     * @param {json} zaicoMoneyJson - 在庫金額一覧Json
     * @param {json} histories - 変更履歴一覧Json
     * @return {json} - zaicoMoneyJson 在庫金額一覧Json
     */
    addNewlyAddedQuantity(zaicoMoneyJson, purchasesItemsSorted) {
      console.log("start addNewlyAddedQuantity");
      for (let zaicoId in purchasesItemsSorted) {
        if (zaicoMoneyJson[zaicoId]) {
          // console.log(zaicoId + ":期間Fromに存在していた在庫。今回は新規追加が対象なのでスルーする。");
          continue;
        }
        if (!this.iventoriesAtDateTo[zaicoId]) {
          // console.log(zaicoId + ":期間To時点に存在しない在庫。期間中に作成して削除したらしい。スルーする。");
          continue;
        }
        let remainingQuantity = Number(this.iventoriesAtDateTo[zaicoId].quantity);
        purchasesItemsSorted[zaicoId].forEach((purchase) => {
          if (!purchase.quantity) return;
          remainingQuantity -= Number(purchase.quantity);
        });
        // 期間中の新規追加データがある
        if (remainingQuantity > 0) {
          let newZaicoMoney = JSON.parse(JSON.stringify(this.iventoriesAtDateTo[zaicoId]));
          delete newZaicoMoney["quantity"];
          newZaicoMoney["仕入日"] = "";
          newZaicoMoney["仕入単価"] = null;
          newZaicoMoney["入庫の数量"] = Number(remainingQuantity);
          zaicoMoneyJson[zaicoId] = [];
          zaicoMoneyJson[zaicoId].unshift(newZaicoMoney);
        }
      }
      console.log("end addNewlyAddedQuantity");
      return zaicoMoneyJson;
    },

    /**
     * 在庫金額一覧jsonに入庫の列を追加する。
     * @type {function}
     * @param {json} zaicoMoneyJson - 在庫金額一覧Json
     * @param {json} histories - 変更履歴一覧Json
     * @return {json} - zaicoMoneyJson 在庫金額一覧Json
     */
    addReceiveZaicoMoney(zaicoMoneyJson, purchasesItemsSorted, iventoriesAtDateTo) {
      console.log("start addReceiveZaicoMoney");
      // 入庫データを追加
      for (let zaicoId in purchasesItemsSorted) {
        purchasesItemsSorted[zaicoId]
          .slice()
          .reverse()
          .forEach((purchase) => {
            if (!purchase.quantity) return;
            if (purchase.quantity <= 0) return;
            if (!iventoriesAtDateTo[zaicoId]) {
              // console.log(zaicoId + ":期間To時点で存在しない在庫。スルーする。");
              return;
            }
            if (!zaicoMoneyJson[zaicoId]) {
              // console.log(
              //   zaicoId + ":入庫データには存在するが、在庫金額一覧に存在しない在庫ID。期間中に新規登録したという事。"
              // );
              zaicoMoneyJson[zaicoId] = [];
            }
            let newZaicoMoney = JSON.parse(JSON.stringify(iventoriesAtDateTo[zaicoId]));
            delete newZaicoMoney["quantity"];
            newZaicoMoney["仕入日"] = purchase.purchase_date;
            newZaicoMoney["仕入単価"] = purchase.unit_price;
            // 同じ仕入日のロットを先入先出で引き当てる際のタイブレーク用（出力前に削除する）
            newZaicoMoney["_purchase_id"] = purchase.purchase_id == null ? null : purchase.purchase_id;
            newZaicoMoney["入庫の数量"] = Number(purchase.quantity);
            zaicoMoneyJson[zaicoId].push(newZaicoMoney);
          });
      }
      console.log("end addReceiveZaicoMoney");
      return zaicoMoneyJson;
    },

    /**
     * 在庫金額一覧jsonに出庫の列を追加する。
     * @type {function}
     * @param {json} zaicoMoneyJson - 在庫金額一覧Json
     * @param {json} histories - 変更履歴一覧Json
     * @return {json} - zaicoMoneyJson 在庫金額一覧Json
     */
    addShippingOutZaicoMoney(zaicoMoneyJson, deliveriesSorted, dateFrom) {
      console.log("start addShippingOutZaicoMoney");
      // 出庫データを追加
      for (let zaicoId in deliveriesSorted) {
        // 削除済みの在庫。スルーする
        if (!zaicoMoneyJson[zaicoId]) {
          continue;
        }
        // 入庫のインデックス
        let i = 0;
        // 出庫のインデックス
        let j = 0;
        // 残りの数量。abs(入庫数量 - 出庫数量)
        let remainingQuantity = 0;
        // 入庫と出庫のどちらが残っているか
        let remainingWhich = ""; // receive or shippingOut
        while (true) {
          // 最後の出庫データまで辿り着いたのでbreak
          if (deliveriesSorted[zaicoId].length <= j) {
            break;
          }
          // 数量がnullなのでスルー
          if (!deliveriesSorted[zaicoId][j].quantity) {
            j++;
            continue;
          }
          // 数量が0なのでスルー
          if (Number(deliveriesSorted[zaicoId][j].quantity) == 0) {
            j++;
            continue;
          }
          if (Number(deliveriesSorted[zaicoId][j].quantity) < 0) {
            // 想定外の値
            console.error(zaicoId + ":出庫の数量がマイナス。なにかがおかしい！");
            console.error(deliveriesSorted[zaicoId][j]);
            break;
          }
          if (zaicoMoneyJson[zaicoId].length < i) {
            console.log(zaicoId + ":最後の入庫データを超えた。入庫数量より出庫数量の方が多い。なにかがおかしい！");
            console.log(zaicoMoneyJson[zaicoId]);
            break;
          }
          let zaicoMoney = zaicoMoneyJson[zaicoId][i];
          if (!zaicoMoney) break;
          zaicoMoney["出庫の数量"] = zaicoMoney["出庫の数量"] ? zaicoMoney["出庫の数量"] : 0;
          let shippingOut = deliveriesSorted[zaicoId][j];
          let shippingOutQuantity = Number(shippingOut.quantity);
          const zaicoMoneyQuantity = zaicoMoney[dateFrom + "の数量"]
            ? Number(zaicoMoney[dateFrom + "の数量"])
            : Number(zaicoMoney["入庫の数量"]);
          // 引き当て先の数量がない場合は次に進む
          if (!zaicoMoneyQuantity) {
            i++;
            continue;
          }
          remainingQuantity = remainingQuantity ? remainingQuantity : zaicoMoneyQuantity;
          // 前回は入庫数量の方が多かった場合
          if (remainingWhich == "receive") {
            if (remainingQuantity < shippingOutQuantity) {
              remainingWhich = "shippingOut";
              i++;
            } else if (remainingQuantity > shippingOutQuantity) {
              remainingWhich = "receive";
              j++;
            } else {
              remainingWhich = "";
              i++;
              j++;
            }
            zaicoMoney["出庫の数量"] += Math.min(Number(remainingQuantity), Number(shippingOutQuantity));
            remainingQuantity = Math.abs(remainingQuantity - shippingOutQuantity);
          } else if (remainingWhich == "shippingOut") {
            // 前回は出庫の数量の方が多かった場合
            if (zaicoMoneyQuantity < remainingQuantity) {
              remainingWhich = "shippingOut";
              i++;
            } else if (zaicoMoneyQuantity > remainingQuantity) {
              remainingWhich = "receive";
              j++;
            } else {
              remainingWhich = "";
              i++;
              j++;
            }
            zaicoMoney["出庫の数量"] += Math.min(Number(zaicoMoneyQuantity), Number(remainingQuantity));
            remainingQuantity = Math.abs(zaicoMoneyQuantity - remainingQuantity);
          } else {
            // 前回は数量が一致していた場合
            if (zaicoMoneyQuantity < shippingOutQuantity) {
              remainingWhich = "shippingOut";
              i++;
            } else if (zaicoMoneyQuantity > shippingOutQuantity) {
              remainingWhich = "receive";
              j++;
            } else {
              remainingWhich = "";
              i++;
              j++;
            }
            zaicoMoney["出庫の数量"] = Math.min(Number(zaicoMoneyQuantity), Number(shippingOutQuantity));
            remainingQuantity = Math.abs(zaicoMoneyQuantity - shippingOutQuantity);
          }
        }
      }

      console.log("end addShippingOutZaicoMoney");
      return zaicoMoneyJson;
    },

    /**
     * 同じ単価のデータを１つにまとめる
     * @type {function}
     * @param {json} zaicoMoneyJson - 在庫金額一覧Json
     * @return {json} - zaicoMoneyJson 在庫金額一覧Json
     */
    aggregateSameUnitPrice(zaicoMoneyJson, dateFrom) {
      console.log("start aggregateSameUnitPrice");
      for (let zaicoId in zaicoMoneyJson) {
        // 比較しやすいように仕入単価でソート
        zaicoMoneyJson[zaicoId] = zaicoMoneyJson[zaicoId].sort(function (a, b) {
          if (a["仕入単価"] !== b["仕入単価"]) {
            return a["仕入単価"] - b["仕入単価"];
          }
          return 0;
        });

        let previousZaicoMoney = {};
        for (var i = 0; i < zaicoMoneyJson[zaicoId].length; i++) {
          let zaicoMoney = zaicoMoneyJson[zaicoId][i];
          // 計算しやすいようにnullを0に置き換える
          zaicoMoney[dateFrom + "の数量"] = zaicoMoney[dateFrom + "の数量"]
            ? zaicoMoney[dateFrom + "の数量"]
            : 0;
          zaicoMoney["入庫の数量"] = zaicoMoney["入庫の数量"] ? zaicoMoney["入庫の数量"] : 0;
          zaicoMoney["出庫の数量"] = zaicoMoney["出庫の数量"] ? zaicoMoney["出庫の数量"] : 0;

          if (zaicoMoney["仕入単価"] != previousZaicoMoney["仕入単価"]) {
            previousZaicoMoney = JSON.parse(JSON.stringify(zaicoMoney));
            continue;
          }
          if (i == 0) {
            previousZaicoMoney = JSON.parse(JSON.stringify(zaicoMoney));
            continue;
          }

          // 仕入単価が同じデータは１つにまとめる
          zaicoMoney[dateFrom + "の数量"] += previousZaicoMoney[dateFrom + "の数量"];
          zaicoMoney["入庫の数量"] += previousZaicoMoney["入庫の数量"];
          zaicoMoney["出庫の数量"] += previousZaicoMoney["出庫の数量"];
          if (zaicoMoney["仕入日"] == previousZaicoMoney["仕入日"]) {
            zaicoMoney["仕入日"] = previousZaicoMoney["仕入日"];
          } else {
            zaicoMoney["仕入日"] += "、" + previousZaicoMoney["仕入日"];
          }
          previousZaicoMoney = JSON.parse(JSON.stringify(zaicoMoney));
          if (i > 0) delete zaicoMoneyJson[zaicoId][i - 1];
        }
      }
      console.log("end aggregateSameUnitPrice");
      return zaicoMoneyJson;
    },

    /**
     * 在庫金額を計算する。
     * @type {function}
     * @param {json} zaicoMoneyJson - 在庫金額一覧Json
     * @return {json} - zaicoMoneyJson 在庫金額一覧Json
     */
    calcZaicoMoney(zaicoMoneyJson) {
      console.log("start calcZaicoMoney");
      for (let zaicoId in zaicoMoneyJson) {
        zaicoMoneyJson[zaicoId].forEach((zaicoMoney) => {
          zaicoMoney[this.dateTo + "の数量"] =
            zaicoMoney[this.dateFrom + "の数量"] + zaicoMoney["入庫の数量"] - zaicoMoney["出庫の数量"];
          if (!zaicoMoney["仕入単価"]) return;
          zaicoMoney[this.dateFrom + "の在庫金額"] = zaicoMoney["仕入単価"] * zaicoMoney[this.dateFrom + "の数量"];
          zaicoMoney["入庫の在庫金額"] = zaicoMoney["仕入単価"] * zaicoMoney["入庫の数量"];
          zaicoMoney["出庫の在庫金額"] = zaicoMoney["仕入単価"] * zaicoMoney["出庫の数量"];
          zaicoMoney[this.dateTo + "の在庫金額"] = zaicoMoney["仕入単価"] * zaicoMoney[this.dateTo + "の数量"];
        });
      }
      console.log("end calcZaicoMoney");
      return zaicoMoneyJson;
    },

    /**
     * 不要なデータを取り除く
     * @type {function}
     * @return {json} - zaicoMoneyJson 在庫金額一覧Json
     */
    remove_unnecessary_data(zaicoMoneyJson) {
      console.log("start remove_unnecessary_data");

      for (let zaicoId in zaicoMoneyJson) {
        zaicoMoneyJson[zaicoId] = zaicoMoneyJson[zaicoId].filter((zaicoMoney) => {
          const requiredFields = [`${this.dateFrom}の数量`, "入庫の数量", "出庫の数量", `${this.dateTo}の数量`];
          const allNull = requiredFields.every((field) => zaicoMoney[field] == null || zaicoMoney[field] == 0);
          return !allNull;
        });
      }

      console.log("end remove_unnecessary_data");
      return zaicoMoneyJson;
    },

    /**
     * jsonの在庫金額一覧をlist形式に変換する。
     * @type {function}
     * @param {json} zaicoMoneyJson - 在庫金額一覧Json
     * @return {array} - zaicoMoneyList 在庫金額一覧
     */
    convertJsonToList(zaicoMoneyJson) {
      console.log("start convertJsonToList");
      let zaicoMoneyList = [];
      for (let zaicoId in zaicoMoneyJson) {
        zaicoMoneyJson[zaicoId].forEach((zaicoMoney) => {
          let newZaicoMoney = JSON.parse(JSON.stringify(zaicoMoney));

          // カラム順を変更する
          var pairs = Object.entries(newZaicoMoney);
          if (this.selectedLanguage == "ja") {
            pairs.splice(2, 0, ["物品名", newZaicoMoney["title"]]);
            pairs.splice(3, 0, ["仕入単価", newZaicoMoney["仕入単価"]]);
            pairs.splice(4, 0, ["仕入日", newZaicoMoney["仕入日"]]);
            pairs.splice(5, 0, [this.dateFrom + "の数量", newZaicoMoney[this.dateFrom + "の数量"]]);
            pairs.splice(6, 0, [this.dateFrom + "の在庫金額", newZaicoMoney[this.dateFrom + "の在庫金額"]]);
            pairs.splice(7, 0, ["入庫の数量", newZaicoMoney["入庫の数量"]]);
            pairs.splice(8, 0, ["入庫の在庫金額", newZaicoMoney["入庫の在庫金額"]]);
            pairs.splice(9, 0, ["出庫の数量", newZaicoMoney["出庫の数量"]]);
            pairs.splice(10, 0, ["出庫の在庫金額", newZaicoMoney["出庫の在庫金額"]]);
            pairs.splice(11, 0, [this.dateTo + "の数量", newZaicoMoney[this.dateTo + "の数量"]]);
            pairs.splice(12, 0, [this.dateTo + "の在庫金額", newZaicoMoney[this.dateTo + "の在庫金額"]]);
          } else {
            pairs.splice(2, 0, ["Title", newZaicoMoney["title"]]);
            pairs.splice(3, 0, ["Purchase Price", newZaicoMoney["仕入単価"]]);
            pairs.splice(4, 0, ["Purchase Day", newZaicoMoney["仕入日"]]);
            pairs.splice(5, 0, ["Quantity at " + this.dateFrom, newZaicoMoney[this.dateFrom + "の数量"]]);
            pairs.splice(6, 0, [
              "Inventory Money Amount at " + this.dateFrom,
              newZaicoMoney[this.dateFrom + "の在庫金額"],
            ]);
            pairs.splice(7, 0, ["Incoming Quantity", newZaicoMoney["入庫の数量"]]);
            pairs.splice(8, 0, ["Incoming Inventory Money Amount", newZaicoMoney["入庫の在庫金額"]]);
            pairs.splice(9, 0, ["Outgoing quantity", newZaicoMoney["出庫の数量"]]);
            pairs.splice(10, 0, ["Outgoing Inventory Money Amount", newZaicoMoney["出庫の在庫金額"]]);
            pairs.splice(11, 0, ["Quantity at " + this.dateTo, newZaicoMoney[this.dateTo + "の数量"]]);
            pairs.splice(12, 0, [
              "Quantity Inventory Money Amount" + this.dateTo,
              newZaicoMoney[this.dateTo + "の在庫金額"],
            ]);
          }
          newZaicoMoney = Object.fromEntries(pairs);
          delete newZaicoMoney["title"];
          delete newZaicoMoney["updated_at"];
          delete newZaicoMoney["created_at"];
          delete newZaicoMoney["operation_datetime"];
          delete newZaicoMoney["item_image"];
          delete newZaicoMoney["quantity_management_attributes"];
          delete newZaicoMoney["stocktake_attributes"];
          delete newZaicoMoney["取引先"];
          delete newZaicoMoney["_purchase_id"];

          zaicoMoneyList.push(newZaicoMoney);
        });
      }
      console.log("end convertJsonToList");
      return zaicoMoneyList;
    },

    // 集計データを作成する
    createAggregatedZaicoMoney(
      zaicoMoneyJson,
      aggregateKey,
      dateFromQuantityField,
      dateFromZaicoMoneyField,
      dateToQuantityField,
      dateToZaicoMoneyField,
      purchaseQuantityField,
      purchaseZaicoMoneyField,
      packingSlipQuantityField,
      packingSlipZaicoMoneyField
    ) {
      console.log("start createAggregatedZaicoMoney");
      const resultMap = new Map();

      zaicoMoneyJson.reverse().forEach((item) => {
        const dateFromQuantityValue = (item[dateFromQuantityField] || 0);
        const dateFromZaicoMoneyValue = (item[dateFromZaicoMoneyField] || 0);
        const dateToQuantityValue = (item[dateToQuantityField] || 0);
        const dateToZaicoMoneyValue = (item[dateToZaicoMoneyField] || 0);
        const purchaseQuantityValue = (item[purchaseQuantityField] || 0);
        const purchaseZaicoMoneyValue = (item[purchaseZaicoMoneyField] || 0);
        const packingSlipQuantityValue = (item[packingSlipQuantityField] || 0);
        const packingSlipZaicoMoneyValue = (item[packingSlipZaicoMoneyField] || 0);

        if (!resultMap.has(item.id)) {
          const newItem = { ...item };
          newItem[dateFromQuantityField] = dateFromQuantityValue;
          newItem[dateFromZaicoMoneyField] = dateFromZaicoMoneyValue;
          newItem[dateToQuantityField] = dateToQuantityValue;
          newItem[dateToZaicoMoneyField] = dateToZaicoMoneyValue;
          newItem[purchaseQuantityField] = purchaseQuantityValue;
          newItem[purchaseZaicoMoneyField] = purchaseZaicoMoneyValue;
          newItem[packingSlipQuantityField] = packingSlipQuantityValue;
          newItem[packingSlipZaicoMoneyField] = packingSlipZaicoMoneyValue;
          newItem[aggregateKey] = item[aggregateKey] !== null ? [item[aggregateKey]] : [];
          resultMap.set(item.id, newItem);
        } else {
          const existingItem = resultMap.get(item.id);
          existingItem[dateFromQuantityField] = (existingItem[dateFromQuantityField] || 0) + dateFromQuantityValue;
          existingItem[dateFromZaicoMoneyField] =
            (existingItem[dateFromZaicoMoneyField] || 0) + dateFromZaicoMoneyValue;
          existingItem[dateToQuantityField] = (existingItem[dateToQuantityField] || 0) + dateToQuantityValue;
          existingItem[dateToZaicoMoneyField] = (existingItem[dateToZaicoMoneyField] || 0) + dateToZaicoMoneyValue;
          existingItem[purchaseQuantityField] = (existingItem[purchaseQuantityField] || 0) + purchaseQuantityValue;
          existingItem[purchaseZaicoMoneyField] =
            (existingItem[purchaseZaicoMoneyField] || 0) + purchaseZaicoMoneyValue;
          existingItem[packingSlipQuantityField] =
            (existingItem[packingSlipQuantityField] || 0) + packingSlipQuantityValue;
          existingItem[packingSlipZaicoMoneyField] =
            (existingItem[packingSlipZaicoMoneyField] || 0) + packingSlipZaicoMoneyValue;

          if (item[aggregateKey] !== null) {
            existingItem[aggregateKey].push(item[aggregateKey]);
          }

          Object.keys(item).forEach((key) => {
            if (
              key !== dateFromQuantityField &&
              key !== dateFromZaicoMoneyField &&
              key !== dateToQuantityField &&
              key !== dateToZaicoMoneyField &&
              key !== purchaseQuantityField &&
              key !== purchaseZaicoMoneyField &&
              key !== packingSlipQuantityField &&
              key !== packingSlipZaicoMoneyField &&
              key !== "id" &&
              key !== aggregateKey
            ) {
              if (existingItem[key] !== item[key]) {
                if (typeof existingItem[key] === "string" && !existingItem[key].includes(item[key])) {
                  existingItem[key] += `、${item[key]}`;
                } else if (existingItem[key] !== item[key]) {
                  existingItem[key] = `${existingItem[key]}、${item[key]}`;
                }
              }
            }
          });
        }
      });

      const resultArray = Array.from(resultMap.values()).map((item) => {
        item[aggregateKey] = item[aggregateKey].length > 0 ? item[aggregateKey].join("、") : null;
        return item;
      });

      console.log(resultArray);
      console.log("end createAggregatedZaicoMoney");
      return resultArray;
    },

    rowStyleClassFn(row) {
      return ((row[this.dateFrom + "の数量"] > 0 && row[this.dateTo + "の数量"] > 0 && !row["仕入単価"]) || this.calc_errors[row["id"]]) ? "red" : "";
    },
    today() {
      var today = new Date();
      today.setDate(today.getDate());
      var yyyy = today.getFullYear();
      var mm = ("0" + (today.getMonth() + 1)).slice(-2);
      var dd = ("0" + today.getDate()).slice(-2);
      return yyyy + "-" + mm + "-" + dd;
    },
    beforeday(day) {
      let beforeday = new Date(day);
      beforeday.setDate(beforeday.getDate() - 1);
      const yyyy = beforeday.getFullYear();
      const mm = ("0" + (beforeday.getMonth() + 1)).slice(-2);
      const dd = ("0" + beforeday.getDate()).slice(-2);
      return yyyy + "-" + mm + "-" + dd;
    },
    /**
     * 先月の月末
     */
    endOfLastMonth() {
      const today = new Date();
      const endOfLastMonth = new Date(today.getFullYear(), today.getMonth(), 0);
      const yyyy = endOfLastMonth.getFullYear();
      const mm = ("0" + (endOfLastMonth.getMonth() + 1)).slice(-2);
      const dd = ("0" + endOfLastMonth.getDate()).slice(-2);
      return yyyy + "-" + mm + "-" + dd;
    },
    /**
     * 先々月の月末
     */
    endOfTwoMonthsAgo() {
      const today = new Date();
      let endOfTwoMonthsAgo = new Date(today.getFullYear(), today.getMonth(), 0);
      endOfTwoMonthsAgo = new Date(endOfTwoMonthsAgo.getFullYear(), endOfTwoMonthsAgo.getMonth(), 1);
      const yyyy = endOfTwoMonthsAgo.getFullYear();
      const mm = ("0" + (endOfTwoMonthsAgo.getMonth() + 1)).slice(-2);
      const dd = ("0" + endOfTwoMonthsAgo.getDate()).slice(-2);
      return yyyy + "-" + mm + "-" + dd;
    },

    calcTotalAmount(zaicoMoneyList) {
      zaicoMoneyList.forEach((zaicoMoney) => {
        if (zaicoMoney[this.dateFrom + "の在庫金額"]) {
          this.totalAmountDateFrom += zaicoMoney[this.dateFrom + "の在庫金額"];
        }
        if (zaicoMoney["入庫の在庫金額"]) {
          this.totalAmountReceive += zaicoMoney["入庫の在庫金額"];
        }
        if (zaicoMoney["出庫の在庫金額"]) {
          this.totalAmountShippingOut += zaicoMoney["出庫の在庫金額"];
        }
        if (zaicoMoney[this.dateTo + "の在庫金額"]) {
          this.totalAmountDateTo += zaicoMoney[this.dateTo + "の在庫金額"];
        }
      });
    },
    /**
     * データ取得開始
     */
    aggregateBtnClicked() {
      this.initialize();
      if (this.dateTo <= this.dateFrom) {
        this.showError(this.$t("Home.correctPeriodad"));
        return;
      }
      this.isLoading = true;
      localStorage.setItem("is_only_purchase_and_packing_slip", this.is_only_purchase_and_packing_slip);
      localStorage.setItem("is_use_inventory_unit_price", this.is_use_inventory_unit_price);
      this.mainLoopFetchInventories();
      this.mainLoopFetchPastInventories();
      this.mainLoopFetchCurrentInventories();
      this.mainLoopFetchAllHistories();
      this.mainLoopFetchPurchasesItems();
      this.mainLoopFetchDeliveries();
    },
    /**
     * 期間Toの在庫一覧
     * 期間中の新規追加データの在庫情報として利用する
     */
    async mainLoopFetchInventories() {
      this.isCompletedFetchInventories = false;
      const iventoriesAtDateToList = await this.loopFetchInventories(this.dateTo);
      iventoriesAtDateToList.forEach((inventory) => {
        this.iventoriesAtDateTo[inventory.id] = inventory;
      });
      console.log("iventoriesAtDateTo: ");
      console.log(JSON.parse(JSON.stringify(this.iventoriesAtDateTo)));
      this.isCompletedFetchInventories = true;
    },
    /**
     * 期間Fromの在庫一覧
     */
    async mainLoopFetchPastInventories() {
      this.isCompletedPastFetchPastInventories = false;
      this.pastInventories = await this.loopFetchInventories(this.dateFrom);
      this.isCompletedFetchPastInventories = true;
    },
    /**
     * 現在の在庫一覧
     */
    async mainLoopFetchCurrentInventories() {
      this.isCompletedFetchCurrentInventories = false;
      this.current_inventories = await this.loopFetchInventories(this.today());
      this.isCompletedFetchCurrentInventories = true;
    },
    /**
     * 変更履歴一覧
     */
    async mainLoopFetchAllHistories() {
      this.isCompletedFetchAllHistories = false;
      try {
        this.all_histories = await this.loopFetchHistories("2000-01-01", this.nextday(new Date()), "changed");
        console.log("this.all_histories: ");
        console.log(JSON.parse(JSON.stringify(this.all_histories)));

        this.histories_plus = this.fillter_histories_plus(this.all_histories);
        console.log("this.histories_plus: ");
        console.log(JSON.parse(JSON.stringify(this.histories_plus)));

        this.histories_canceled = this.fillter_histories_canceled(this.all_histories, new Date(this.dateFrom));
        console.log("this.histories_canceled: ");
        console.log(JSON.parse(JSON.stringify(this.histories_canceled)));

        this.isCompletedFetchAllHistories = true;
      } catch (e) {
        console.error(e);
        this.showError("変更履歴の集計中にエラーが発生しました: " + (e && e.message ? e.message : e));
      }
    },
    /**
     * 仕入物品一覧
     */
    async mainLoopFetchPurchasesItems() {
      this.isCompletedFetchPurchasesItems = false;
      this.purchase_items = await this.loopFetchPurchasesItems();
      console.log("[this.loopFetchPurchasesItems] this.purchase_items: ");
      console.log(JSON.parse(JSON.stringify(this.purchase_items)));
      this.isCompletedFetchPurchasesItems = true;
    },
    /**
     * 出庫明細一覧
     */
    async mainLoopFetchDeliveries() {
      this.isCompletedFetchDeliveries = false;
      this.deliveries = await this.loopFetchDeliveries();
      console.log("this.deliveries: ");
      console.log(JSON.parse(JSON.stringify(this.deliveries)));
      this.isCompletedFetchDeliveries = true;
    },
    /**
     * キャンセル
     */
    cancel() {
      this.isLoading = false;
      this.initialize();
    },
    /**
     * 初期化
     */
    initialize() {
      this.zaicoMoneyList = [];
      this.zaicoMoneyAggregatedList = [];
      this.pastInventories = [];
      this.iventoriesAtDateTo = {};
      this.current_inventories = [];
      this.all_histories = {};
      this.histories_canceled = {};
      this.purchase_items = {};
      this.deliveries = {};
      this.isCompletedFetchPastInventories = false;
      this.isCompletedFetchInventories = false;
      this.isCompletedFetchCurrentInventories = false;
      this.isCompletedFetchAllHistories = false;
      this.isCompletedFetchPurchasesItems = false;
      this.isCompletedFetchDeliveries = false;
      this.isCompletedCreateZaicoMoneyList = false;
      this.previousIsCompletedFetchAll = false;
      this.isLoading = false;
      this.isShowError = false;
      this.isShowPreview = false;
      this.isShowAggregatedPreview = false;
      this.errorMsg = "";
      this.columns = [];
      this.column_names = [];
      this.progress = 0;
      this.progressPercentStr = "";
      this.hasNoPriceData = false;
      this.totalAmountDateFrom = 0;
      this.totalAmountDateTo = 0;
      this.totalAmountReceive = 0;
      this.totalAmountShippingOut = 0;
      this.calc_errors = {};
    },

    /**
     * APIから変更履歴一覧を取得する
     */
    async fetchHistories(accessToken, pageToken, start_date, end_date, quantity_diff_option) {
      try {
        let _params = {
          accessToken: accessToken,
          pageToken: pageToken,
          end_date: end_date,
          quantity_diff_option: quantity_diff_option,
        };
        if (start_date) _params["start_date"] = start_date;
        return await axios.get("/inventory_histories", {
          params: _params,
        });
      } catch (e) {
        console.log("変更履歴API　でエラー");
        console.log(e);
        let message = e.toString();
        if (message.match(/Network Error/)) {
          message = "TimeOut Error";
        }
        return {
          data: {
            code: -1,
            message: message,
          },
        };
      }
    },

    /**
     * プレビューを開く
     */
    openPreview() {
      this.$gtag.event("プレビューを開く", { user_id: this.userId });
      this.isShowPreview = true;
    },

    /**
     * 集計プレビューを開く
     */
    openAggregatedPreview() {
      this.$gtag.event("集計プレビューを開く", { user_id: this.userId });
      this.isShowAggregatedPreview = true;
    },

    /**
     * プレビューを閉じる
     */
    closePreview() {
      this.$gtag.event("プレビューを閉じる", { user_id: this.userId });
      this.isShowPreview = false;
    },

    /**
     * 集計プレビューを閉じる
     */
    closeAggregatedPreview() {
      this.$gtag.event("集計プレビューを閉じる", { user_id: this.userId });
      this.isShowAggregatedPreview = false;
    },

    /**
     * エラー処理
     */
    showError(message) {
      this.$gtag.event("showError", { user_id: this.userId, errMsg: message });

      if (message == "Could not access API. This token is expired.") {
        alert(message);
        window.location.reload();
        return;
      }
      this.isLoading = false;
      this.isShowError = true;
      this.errorMsg = message;
    },
  },
};
</script>

<style>
.home {
  margin: 1.5rem 1.5rem 1.5rem 1.5rem;
}

.content {
  margin-left: 1rem;
}

.btn-info {
  color: #fff;
}

.btn-info:hover {
  color: #fff;
}

.language {
  float: right;
}

.green {
  background: green !important;
}

.red {
  background: rgb(253, 203, 203);
}

th {
  white-space: nowrap;
}

td {
  white-space: nowrap;
}
</style>
